import MarketplaceAccessSchema, { MarketplaceAccessParams, MarketplaceAccessJSON } from "permissions/resources/marketplace/_schema/marketplace-access-schema";
import MarketplaceSearchAccessSchema, { MarketplaceSearchAccessJSON, MarketplaceSearchAccessParams } from "permissions/resources/marketplace/_schema/marketplace-search-access-schema";
import { Resource } from "permissions/resources/permission-resource";
import { registerResource } from "permissions/resources/resource-registry";
import { AccessLevel, AnyResourceJSON, ResourceFromJSON, ResourceType, Scope } from "permissions/resources/types";

export class MarketplaceAccess extends Resource {
  public static create(params?: MarketplaceAccessParams): MarketplaceAccess {
    const parsed = MarketplaceAccessSchema.validate(params);
    return new MarketplaceAccess(parsed);
  }

  public static fromJSON<J extends AnyResourceJSON>(json: J): ResourceFromJSON<J> {
    const parsed = MarketplaceAccessSchema.deserialize(json as MarketplaceAccessJSON);
    return new MarketplaceAccess(parsed) as ResourceFromJSON<J>;
  }

  public static getPermutations(): MarketplaceAccess[] {
    const fieldIterations: [key: string, value: number[]][] = [
      ['accessLevel', Object.values(AccessLevel).filter((key) => !Number.isNaN(Number(key))).map(Number)],
      ['scope', Object.values(Scope).filter((key) => !Number.isNaN(Number(key))).map(Number)],
    ];
    return this.generatePermutations(MarketplaceAccess, fieldIterations) as MarketplaceAccess[];
  }

  public readonly resourceType = ResourceType.MarketplaceAccess;
  public readonly accessLevel?: AccessLevel;
  public readonly scope?: Scope;
  
  public toJSON(): MarketplaceAccessJSON {
    return MarketplaceAccessSchema.serialize(this);
  }

  public override toString(): string {
    return `MarketplaceAccess {
      resourceType: ${this.resourceType}
      isDisabled: ${this.isDisabled ? 'true' : 'false'}
      resourceTypeText: ${this.resourceTypeText}
      accessLevel: ${this.accessLevel},
      scope: ${this.scope}
    }`;
  }

  public constructor(params?: MarketplaceAccessParams) {
    super(params);

    if (params) {
      this.accessLevel = params.accessLevel;
      this.scope = params.scope;
    }
  }
}

registerResource("MarketplaceAccess", (json) => MarketplaceAccess.fromJSON(json));



export class MarketplaceSearchAccess extends Resource {
  public static create(params?: MarketplaceSearchAccessParams): MarketplaceSearchAccess {
    const parsed = MarketplaceSearchAccessSchema.validate(params);
    return new MarketplaceSearchAccess(parsed);
  }

  public static fromJSON<J extends AnyResourceJSON>(json: J): ResourceFromJSON<J> {
    const parsed = MarketplaceSearchAccessSchema.deserialize(json as MarketplaceSearchAccessJSON);
    return new MarketplaceSearchAccess(parsed) as ResourceFromJSON<J>;
  }

  public static getPermutations(): MarketplaceSearchAccess[] {
    const fieldIterations: [key: string, value: number[]][] = [
      ['accessLevel', Object.values(AccessLevel).filter((key) => !Number.isNaN(Number(key))).map(Number)],
      ['scope', Object.values(Scope).filter((key) => !Number.isNaN(Number(key))).map(Number)],
    ];
    return this.generatePermutations(MarketplaceSearchAccess, fieldIterations) as MarketplaceSearchAccess[];
  }

  public readonly resourceType = ResourceType.MarketplaceSearchAccess;
  public readonly accessLevel?: AccessLevel;
  public readonly scope?: Scope;
  
  public toJSON(): MarketplaceSearchAccessJSON {
    return MarketplaceSearchAccessSchema.serialize(this);
  }

  public override toString(): string {
    return `MarketplaceSearchAccess {
      resourceType: ${this.resourceType}
      isDisabled: ${this.isDisabled ? 'true' : 'false'}
      resourceTypeText: ${this.resourceTypeText}
      accessLevel: ${this.accessLevel},
      scope: ${this.scope}
    }`;
  }

  public constructor(params?: MarketplaceSearchAccessParams) {
    super(params);

    if (params) {
      this.accessLevel = params.accessLevel;
      this.scope = params.scope;
    }
  }
}

registerResource("MarketplaceSearchAccess", (json) => MarketplaceSearchAccess.fromJSON(json));
